
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.221 8.135L.258 2.273C-.328 1.583.148.5 1.038.5h9.926c.2 0 .394.059.561.17.168.111.3.27.383.457a1.102 1.102 0 01-.165 1.147L6.78 8.134a1.038 1.038 0 01-.351.27 1.007 1.007 0 01-1.208-.27v.001z","fill":"gray"}})])
          )
        }
      }
    